<template>
  <div v-if="eventosWeb" class="jumbotron no_space dmbs-container">
    <!-- <v-btn @click="conectar" >click</v-btn> -->

    <!-- <seccion-top5 seccion="top5" ></seccion-top5> -->
    <h2>{{filtroActual}} </h2>
    <pre>

      {{$route}}
    </pre>
  </div>
</template>
<script>
import Cabecera from '@/components/plantilla/Cabecera.vue'
import Menu from '@/components/plantilla/Menu.vue'
import { globales } from "../../components/comunes"

export default {
  mixins: [globales],
  components: {
    Cabecera,
    Menu
  },
  // watch: {
  //   '$route' (to, from) {
  //     // react to route changes...
  //// -- console.log('ruta', to)
  //   }
  // },
  computed: {
    filtroActual(){
      return this.$route
    },
    eventosWeb(){
      return this.$store.state.eventosWeb
    },
    eventosPagina(){
      var filtro 
      switch (this.filtroActual) {
        case 'musicales': filtro = this.eventosWeb.filter(e=>e.Tipo[0].IdMasterTipoE == "6")
          
          break;
      
        default: filtro = this.eventosWeb
          break;
      }

      return filtro
    }
  }
}
</script>
